import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ENRICHMENT_STATE, SearchType } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { useSaveRecord } from '../use-save-record';

export function usePeoplePhoneNumberLoading(item?: PeopleTableInfo) {
  const api = useSaveRecord(SearchType.People);
  const { isItemProcessing } = useActionButtonContext();

  const loading = useMemo(() => {
    const state = item?.revelation?.phone_cached?.state;
    const contextLoading = isItemProcessing({
      id: item?.id ?? '',
      type: QUICK_INFO_BUTTONS.PHONENUMBER_ENRICHMENT,
    });
    if (
      api.isLoading ||
      state === ENRICHMENT_STATE.PROCESSING ||
      contextLoading
    )
      return true;

    return false;
  }, [api.isLoading, item, isItemProcessing]);

  return { loading };
}
